// extracted by mini-css-extract-plugin
export default {"tr":"LastPay_tr__02Il1","tr1":"LastPay_tr1__zjGrY"};